import { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { InputMask } from 'primereact/inputmask';
import { Tree, TreeCheckboxSelectionKeys, TreeMultipleSelectionKeys } from 'primereact/tree';
import { useGlobalState } from '../../../components/globalState/GlobalStateProvider';
import { FilterWeb } from '../../../interface/FilterWeb';
import { Fieldset } from 'primereact/fieldset';
import { PickList } from 'primereact/picklist';
import { InputNumber } from 'primereact/inputnumber';
import { RadioButton } from 'primereact/radiobutton';
import { Divider } from 'primereact/divider';
 
 
export default function FiltroPF({
    onProcess,
    onClose,
    msgs
  }: {
    onProcess: (filterWeb : FilterWeb, automotiva: boolean) => void
    onClose: () => void,
    msgs:any
  }) {
  const { t } = useTranslation();
  const {state} = useGlobalState();
  const [cpf, setCpf] = useState<string>("");
  const [selectedKeys, setSelectedKeys] = useState<string | TreeMultipleSelectionKeys | TreeCheckboxSelectionKeys | null>(null); 
  const [selectedOptionCheck, setSelectedOptionCheck] = useState<any[]>([]);
  const [targets, setTargets] = useState<any[]>([]);
  const [valorCartao, setValorCartao] = useState<number|null|undefined>(null);
  const [cartao, setCartao] = useState<number|null|undefined>(null);
  const [bin, setBin] = useState<number|null|undefined>(null);
  const [selectedFilter, setSelectedFilter] = useState<any>();
  const [opcionais, setOpcionais] = useState<any[]>([]);
  const [validDocument, setValidDocument] = useState<boolean>(false)
 
  const validCPF = (documento:string) => {
    if(verifyCPF(documento)){
      msgs.current?.clear();
      setValidDocument(true);
    }
    else{
      window.scrollTo(0, 0);
      setValidDocument(false);
      msgs.current?.clear();
        msgs.current?.show([
            { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'Documento inválido', closable: false }
          
        ]);
    }
 
  }
 
  const changeFilter = (value:any) => {
    setSelectedKeys(null)
    setSelectedFilter(value);
    setOpcionais(createOptionsOpcionais(value))
  }
 
  const  verifyCPF = (strCPF:string) => {
    strCPF = strCPF.replaceAll('.','').replace('-','')
    let Soma;
    let Resto;
    Soma = 0;
  if (strCPF == "00000000000") return false;
  if (strCPF == "11111111111") return false;
  if (strCPF == "22222222222") return false;
  if (strCPF == "33333333333") return false;
  if (strCPF == "44444444444") return false;
  if (strCPF == "55555555555") return false;
  if (strCPF == "66666666666") return false;
  if (strCPF == "77777777777") return false;
  if (strCPF == "88888888888") return false;
  if (strCPF == "99999999999") return false;
 
  for (let i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;
 
    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;
 
  Soma = 0;
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;
 
    if ((Resto == 10) || (Resto == 11))  Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;
    return true;
}
 
const expandNode = (node:any, _expandedKeys:any) => {
  if (node.children && node.children.length) {
      _expandedKeys[node.key] = true;
 
      for (let child of node.children) {
          expandNode(child, _expandedKeys);
      }
  }
};
 
 
 
const createOptionsOpcionais = (opcao:any) =>{
  const option : any[] = [];
  
  if(opcao.permissoes && opcao.permissoes.length > 0){
    opcao.permissoes
    .sort( (a:any,b:any) => {
      {
        if(!a.ordenacao){
          return 1;
        }
 
        if(!b.ordenacao){
          return -1;
        }
 
        if (a.ordenacao > b.ordenacao) {
          return 1;
        }
        if (a.ordenacao < b.ordenacao) {
          return -1;
        }
        return 0;
      }
    } ).map((element: any) => {
      
      if(element.value == 'QUODPFINDICADORESNEGOCIO_PERFIL' || 
        element.value == 'QUODPFINDICADORESNEGOCIO_MERCADO' ||
        element.value == 'QUODPFINDICADORESNEGOCIO_GESTAO' ||
        element.value == 'QUODPFINDICADORESNEGOCIO_CENARIO' ||
        element.value == 'QUODPFINDICADORESNEGOCIO_PONTUALIDADE'){
        if(targets.filter((s)=>s.value===element.value).length === 0){
          targets.push({value : element.value, target : []})
        }
      }
      option.push({label:element.label, key:element.value, Collapse:true, pickList: targets.filter((s) => s.value === element.value).length != 0 ? element.permissoes : undefined, children: element.permissoes && targets.filter((s) => s.value === element.value).length === 0 ? createPermissoesOpcionaisFilhos(element.permissoes.filter((f: {
        tipoConsulta: string; 
      }) => f.tipoConsulta === 'PF' || f.tipoConsulta === 'PFPJ'), false) : []});
        
     });
    expandAll(option)    
  }
  return option;
}
 
 
const createPermissoesOpcionaisFilhos = (permissoes:any[], first:boolean) => {
  const option : any[] = [];
  if(permissoes){
    permissoes
    .sort( (a:any,b:any) => {
      {
        if(!a.ordenacao){
          return 1;
        }
 
        if(!b.ordenacao){
          return -1;
        }
 
        if (a.ordenacao > b.ordenacao) {
          return 1;
        }
        if (a.ordenacao < b.ordenacao) {
          return -1;
        }
        return 0;
      }
    } )
    .forEach((element: {
      children: any; label: string; value: string; permissoes:any[]  
    }) => {
      option.push({label:element.label, first: first, key:element.value, Collapse:true, pickList: targets.filter((s) => s.value === element.value).length != 0 ? element.permissoes : undefined, children: element.permissoes && targets.filter((s) => s.value === element.value).length === 0 ? createPermissoesOpcionaisFilhos(element.permissoes.filter((f: {
        tipoConsulta: string; 
      }) => f.tipoConsulta === 'PF' || f.tipoConsulta === 'PFPJ'), false) : []});
    });
  }
  return option;
}
 
const createOptions = () =>{
  const option : any[] = [];
 
  state.user.consultas.filter((f: {
    tipoConsulta: string; 
  }) => f.tipoConsulta ===  'PF' || f.tipoConsulta === 'PFPJ')
  .sort( (a:any,b:any) => {
    {
      if(!a.ordenacao){
        return 1;
      }
 
      if(!b.ordenacao){
        return -1;
      }
 
      if (a.ordenacao > b.ordenacao) {
        return 1;
      }
      if (a.ordenacao < b.ordenacao) {
        return -1;
      }
      return 0;
    }
  } )
  .map((element: any) => {
    const filhos = element.permissoes ? element.permissoes.filter((f: {
      tipoConsulta: string; 
    }) => f.tipoConsulta ===  'PF' || f.tipoConsulta === 'PFPJ') : [];
    if(filhos.length > 0){
      option.push({root: true, label:element.label, key:element.value, Collapse:true, children: createPermissoesFilhos(filhos, true)});
    }
      
   });
  expandAll(option)      
  return option;
}
 
const createPermissoesFilhos = (permissoes:any[], first:boolean) => {
  const option : any[] = [];
  if(permissoes){
    permissoes
    .sort( (a:any,b:any) => {
      {
        if(!a.ordenacao){
          return 1;
        }
 
        if(!b.ordenacao){
          return -1;
        }
 
        if (a.ordenacao > b.ordenacao) {
          return 1;
        }
        if (a.ordenacao < b.ordenacao) {
          return -1;
        }
        return 0;
      }
    } )
    .forEach((element: {
      children: any; label: string; value: string; permissoes:any[]  
    }) => {
      if(element.value == 'QUODPFINDICADORESNEGOCIO_PERFIL' || 
        element.value == 'QUODPFINDICADORESNEGOCIO_MERCADO' ||
        element.value == 'QUODPFINDICADORESNEGOCIO_GESTAO' ||
        element.value == 'QUODPFINDICADORESNEGOCIO_CENARIO' ||
        element.value == 'QUODPFINDICADORESNEGOCIO_PONTUALIDADE'){
        if(targets.filter((s)=>s.value===element.value).length === 0){
          targets.push({value : element.value, target : []})
        }
        
      }
      option.push({label:element.label, first: first, key:element.value, Collapse:true, pickList: targets.filter((s) => s.value === element.value).length != 0 ? element.permissoes : undefined, children: [], permissoes:element.permissoes});
    });
  }
  return option;
}
 
const expandAll = (option:any) => {
  let _expandedKeys = {};
 
  for (let node of option) {
      expandNode(node, _expandedKeys);
  }
 
 return _expandedKeys;
};
 
  const processConsulta = () => {
 
    const opcoes: string[] = [];
    if(selectedFilter){
      opcoes.push(selectedFilter.key);
    }
    if(selectedKeys && Object.getOwnPropertyNames(selectedKeys).length){
      Object.getOwnPropertyNames(selectedKeys).map((item) => opcoes.push(item));
    }
    /* else{
      if(selectedFilter.permissoes && selectedFilter.permissoes.length > 0){
        window.scrollTo(0, 0);
        msgs.current?.clear();
          msgs.current?.show([
              { sticky: false, life: 100000, severity: 'error', summary: 'Erro', detail: 'Selecione pelo menos um opcional', closable: false }
            
          ]);
          return;
      }
    }*/
  
    selectedOptionCheck.map((item) => opcoes.push(item.value));
    const filteWeb :FilterWeb = {
      documento: cpf,
      consultas: opcoes,
      valor: null,
      arrojado: null,
      usual: null,
      conservador: null,
      indicadores: targets.filter((s:any) => opcoes.includes(s.value))
    };
    onProcess(filteWeb, false);
  }
  const onChange = (event:any, key:string) => {
    const targetsOut = [{value: key, target: event.target}]
    targets.filter((s:any) => s.value !== key).map((item:any) => targetsOut.push(item));
    setTargets(targetsOut)
};
  const pickItemTemplate = (item:any) => {
    return (
        <div className="flex flex-wrap p-2 align-items-center gap-3">
            <div className="flex-1 flex flex-column gap-2">
                <span className="font-bold">{item.label}</span>
            </div>
        </div>
    );
};
const nodeTemplateRadio = (node: any, options: { className: string | undefined; }) => {
  let label = <div className='grid' style={{alignItems: 'center'}}><RadioButton inputId={node.key} name="filter" value={node} onChange={(e) => changeFilter(e.value)} checked={selectedFilter?.key === node.key} />{selectedFilter?.key === node.key ? (<div style={{paddingLeft: '0.5rem'}}>{nodeTemplate(node)}</div>) : (<label htmlFor={node.key} className="ml-2">{node.label}</label>)}{node.informativo && ( <i data-pr-tooltip={node.informativo} data-pr-position="right" data-pr-at="right+5 top" style={{paddingLeft: '1.5rem', color: '#183462', fontSize: '1.2rem'}} className="custom-target-icon pi pi-question-circle"></i>)}</div>;
  if (node.children.length !== 0) {
     label = <b>{node.label}</b>;
  }
 
  return label;
}
  const nodeTemplate = (node: any) => {
    let label = <span>{node.label}</span>;
    if (node.children.length !== 0 || node.first) {
       label = <b className={node.root ? 'root' : ''} onClick={(e)=> {if(node.root){ e.stopPropagation()}}}>{node.label}</b>;
    }
 
    if(node.key.includes('QUODAUTENTICACARTAO') && ((selectedFilter && selectedFilter === 'QUODAUTENTICACARTAO') || (selectedKeys && Object.getOwnPropertyNames(selectedKeys)?.includes('QUODAUTENTICACARTAO'))) ){
          return <>
          <Fieldset onClick={(e)=> e.stopPropagation()} legend={node.label}>
                      <div className="flex-auto">
                        <label htmlFor="cartao" className="font-bold block mb-2 required">{t('cartao')}</label>
                        <InputNumber inputId="cartao" onValueChange={(e) => setCartao(e.value)} useGrouping={false} size={4} maxLength={4} placeholder='Últimos 4 dígitos do cartão' />
                      </div>
                      <br></br>
                      <div className="flex-auto">
                        <label htmlFor="bin" className="font-bold block mb-2 required">{t('bin')}</label>
                        <InputNumber inputId="bin" onValueChange={(e) => setBin(e.value)}  useGrouping={false} size={9} maxLength={9} placeholder='Primeiros 6 a 9 dígitos do cartão' />
                      </div>
                      <br></br>
                      <div className="flex-auto">
                        <label htmlFor="currency" className="font-bold block mb-2">{t('valor')}</label>
                        <InputNumber inputId="currency" onValueChange={(e) => setValorCartao(e.value)} mode="currency" currency="BRL" locale="pt-BR" />
                      </div>
                      <br></br>
                     
                    </Fieldset>
          </>
        }
 
    if((node.pickList && selectedKeys && ((selectedFilter && selectedFilter.key === node.key) || (Object.getOwnPropertyNames(selectedKeys)?.includes(node.key))))){
     
      return <>
              <Fieldset onClick={(e)=> e.stopPropagation()} legend={node.label}>
                <PickList dataKey="value" onChange={(e) => {onChange(e, node.key)}} itemTemplate={pickItemTemplate} showSourceControls={false} showTargetControls={false} source={node.pickList.filter((s:any) => {return targets.filter((s:any) => s.value === node.key)[0].target.filter((s2:any) => s.value === s2.value).length == 0} )} target={targets.filter((s:any) => s.value === node.key)[0].target}  filter filterBy="label" 
                  sourceHeader="Indicadores" targetHeader="Selecionados" sourceStyle={{ height: '24rem' }} targetStyle={{ height: '24rem' }}
                  sourceFilterPlaceholder="Busca" targetFilterPlaceholder="Busca" />
              </Fieldset>
              </>   
    }
 
    return label
  }
 
 
  return (<>
    <Panel header={t('consultaPF')}>
        <div className=" p-fluid flex flex-wrap gap-3">
            <div className="flex-auto">
                <label htmlFor="cpf" className="font-bold block mb-2 required">CPF</label>
                <InputMask id="cpf" value='cpf' onBlur={(e)=>{setCpf(e.target.value);validCPF(e.target.value)}} mask="999.999.999-99" placeholder="999.999.999-99" required></InputMask>
            </div>
            <br></br>
            <div className=" p-fluid flex flex-wrap gap-3">
              <Tree filter filterMode="lenient" nodeTemplate={nodeTemplateRadio} expandIcon={undefined} collapseIcon={undefined} expandedKeys = {expandAll(createOptions())} value={createOptions()} selectionKeys={selectedKeys} onSelectionChange={(e) => {setSelectedKeys(e.value);  }} style={{border:'none', marginLeft:'-2.0rem', background:'transparent'}}  />
            </div>
            {opcionais && opcionais.length > 0 && ( 
              <div className=" p-fluid flex flex-wrap gap-3">
                <Divider className="automotiva" align="left">
                  <div className="flex-score justify-content-between justify-content-center">
                    <span
                      className="p-tag"
                      style={{
                        position: "relative",
                        backgroundColor: "#183462",
                        fontSize: "1.1rem",
                        height: "2rem",
                       
                      }}
                    >
                      Opcionais
                    </span>
                    </div>
                </Divider>
                <Tree nodeTemplate={nodeTemplate} expandIcon={undefined} collapseIcon={undefined} expandedKeys = {expandAll(opcionais)} value={opcionais} selectionMode='checkbox' selectionKeys={selectedKeys} onSelectionChange={(e) => {setSelectedKeys(e.value);  }} style={{border:'none', marginLeft:'-2.0rem', background:'transparent'}}  />
              </div>
            )}
            
         
        </div>
        <div style={{display:"flex", justifyContent:"flex-end", paddingTop:"1rem"}} className=" flex ">
            <Button disabled={!validDocument} style={{marginRight:"1rem", backgroundColor:'#183462'}} label="Consultar"  onClick={processConsulta} />
            <Button icon="pi pi-times" onClick={onClose} rounded outlined severity="danger" aria-label="Cancel" />
        </div> 
            
    </Panel>
   
    </>
  )
}